export default __webpack_public_path__ + "static/media/alert-legend.39423108.svg";